export interface DateUtilsInterface {
    getDateISOString(dateString: string): string;
    getTimezoneOffset(): number;
    toStringFormat(format: string, dateString?: string): string;
}

class DateUtils implements DateUtilsInterface {
    private timezoneOffset: number;

    constructor() {
        this.timezoneOffset = new Date().getTimezoneOffset();
    }

    getDateISOString(dateString: string): string {
        return new Date(new Date(dateString).getTime() - this.timezoneOffset * 60000)
            .toISOString()
    }

    getTimezoneOffset(): number {
        return this.timezoneOffset;
    }

    toStringFormat(format: string, dateString?: string): string {
        let result = format;
        const date = typeof dateString !== "undefined" ? new Date(dateString) : new Date();
        const month = date.getMonth();
        const hours = date.getHours();
        const config: {[key: string]: number | string} = {
            "M+": month + 1,
            "d+": date.getDate(),
            "h+": hours,
            "H+": hours > 12 ? hours - 12 : hours,
            "m+": date.getMinutes(),
            "s+": date.getSeconds(),
            "q+": Math.floor((month + 3) / 3),
            "S": date.getMilliseconds(),
            "a+": hours > 11 ? "PM" : "AM"
        };

        if (/(y+)/.test(result)) {
            result = result.replace(
                RegExp.$1,
                date.getFullYear().toString().substr(4 - RegExp.$1.length),
            );
        }

        for (let t in config) {
            if (new RegExp("(" + t + ")").test(result)) {
                result = result.replace(RegExp.$1, 1 === RegExp.$1.length
                    ? ("000" + config[t]).substr(config[t].toString().length)
                    : ("00" + config[t]).substr(config[t].toString().length));
            }
        }

        return result;
    }
}

export default new DateUtils();
